// extracted by mini-css-extract-plugin
export default {"melodyRule":"gF-z"};